/* ============
 * Getters for the users module
 * ============
 *
 * The getters that are available on the
 * users module.
 */


export default {
  getDevDataList: state => state.devData.developer,
};



// WEBPACK FOOTER //
// ./src/store/modules/users/getters.js